export enum ServiceSessionEventType {
  CREATED = 'session.created',
  DELIVERED = 'session.delivered',
  REJECTED = 'session.rejected',
  HANGUP = 'session.hangup',
  OFFERED = 'session.offered',
  RESCINDED = 'session.rescinded',
  RECOVERY_COMPLETED = 'sessionsession.wrapup.completed',
  RECOVERY_STARTED = 'session.wrapup.started',
  DELETED = 'session.deleted',
}

export type ServiceSessionEvent = {
  sessionId: string;
  sessionSid: string;
};

export type ServiceSessionUserEvent = ServiceSessionEvent & {
  userId: string;
  agentId: string;
};

export type ServiceSessionCreatedEvent = ServiceSessionEvent & {
  from: string;
  displayName: string;
  tenantId: string;
};

export type ServiceSessionSource = {
  address: string;
  displayName?: string;
};

export type ServiceSessionOfferedEvent = ServiceSessionUserEvent & {
  from: string;
  to: string;
  displayName: string;
  tenantId: string;
  queueName: string;
  queueId: string;
  queueEnterTime: string;
  queueTimeout?: number; // timestamp when queue timeout should occur
  source: ServiceSessionSource;
};

export type ServiceSessionRecoveryEvent = ServiceSessionUserEvent & {
  timestamp: string | number;
  recoveryAllowedMs: number;
};

export default [
  ServiceSessionEventType.CREATED,
  ServiceSessionEventType.DELIVERED,
  ServiceSessionEventType.REJECTED,
  ServiceSessionEventType.HANGUP,
  ServiceSessionEventType.OFFERED,
  ServiceSessionEventType.RESCINDED,
  ServiceSessionEventType.RECOVERY_COMPLETED,
  ServiceSessionEventType.RECOVERY_STARTED,
  ServiceSessionEventType.DELETED,
];
